import { render, staticRenderFns } from "./custom-field-loading.vue?vue&type=template&id=1c84e411"
var script = {}
import style0 from "./custom-field-loading.vue?vue&type=style&index=0&id=1c84e411&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports